import { h } from 'preact';
import PropTypes from 'prop-types';

import AudioPlayer from '../../components/3-molecules/audio-player/audio-player';
import { satelliteTracker } from '../../../services/tracking/satellite-tracking-service';

let lastPercentage = 0;
let hasStarted = false;

const TextToSpeech = ({ actions, htmlProps }) => {
  return (
    <AudioPlayer
      src={htmlProps.source}
      onReady={(data) => {
        const duration = Math.round(data.duration);
        satelliteTracker.trackInWeb('text_to_speech_available', { length: duration });
      }}
      onPlay={(data) => {
        actions.setAudioStarted();
        actions.setAudioPaused(false);
        const duration = Math.round(data.duration);
        if (!hasStarted) {
          satelliteTracker.trackInWeb('text_to_speech_play', { length: duration });
          hasStarted = true;
        }
      }}
      onPause={() => {
        actions.setAudioPaused(true);
      }}
      onComplete={(data) => {
        actions.setAudioCompleted();
        const duration = Math.round(data.duration);
        satelliteTracker.trackInWeb(`text_to_speech_completed`, { length: duration });
      }}
      onSeek={(data) => {
        console.info('player seeked with data', data);
      }}
      onProgress={(data) => {
        const progressPercentage = Math.round(data.progressPercentage);
        if (progressPercentage % 25 === 0 && progressPercentage < 100 && progressPercentage !== lastPercentage) {
          const step = progressPercentage.toString();
          const duration = Math.round(data.duration);
          actions.setAudioPercentage(progressPercentage);
          satelliteTracker.trackInWeb(`text_to_speech_${step}`, { length: duration });
          lastPercentage = progressPercentage;
        }
      }}
    />
  );
};

TextToSpeech.propTypes = {
  actions: PropTypes.object,
  htmlProps: PropTypes.shape({
    source: PropTypes.string.isRequired,
  }),
};

export default TextToSpeech;
